import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { GetUsersReportParams, usersService } from '../../../services';

export function useUsersReport(params: GetUsersReportParams = {}) {
  return useQuery({
    queryKey: ['users-report', params],
    queryFn: async () => {
      const response = await usersService.getUsersReport(params);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar o relatório de usuários'
        );
      }

      return response.data;
    },
    // A API mantém o dataset em cache por 60s; trocar página/filtro não refaz a leitura do Cognito.
    placeholderData: keepPreviousData,
  });
}
